import { supabase } from "../supabaseClient";

const liveInstancesForTemplate = (templateId) =>
  supabase
    .from("tournamentEvents")
    .select("id, squadId, squads:squadId (id, isDeleted)")
    .eq("templateId", templateId)
    .eq("isDeleted", false);

const isLiveSquad = (row) => row.squads && row.squads.isDeleted === false;

export const deleteEventInstancesForSquad = async (squadId) => {
  const { data, error } = await supabase
    .from("tournamentEvents")
    .select("templateId")
    .eq("squadId", squadId)
    .eq("isDeleted", false)
    .not("templateId", "is", null);

  if (error) throw error;

  const templateIds = [
    ...new Set((data || []).map((row) => row.templateId).filter(Boolean)),
  ];
  if (templateIds.length === 0) return;

  const { error: rpcError } = await supabase.rpc(
    "delete_squad_event_instances",
    {
      p_squad_id: squadId,
      p_template_ids: templateIds,
    }
  );
  if (rpcError) throw rpcError;
};

export const countActiveTemplateInstances = async (templateId) => {
  const { data, error } = await liveInstancesForTemplate(templateId);
  if (error) throw error;
  return (data || []).filter(isLiveSquad).length;
};

export const deleteOrphanedTemplateInstances = async (templateId) => {
  const { data, error } = await liveInstancesForTemplate(templateId);
  if (error) throw error;

  const orphans = (data || []).filter(
    (row) => row.squadId && !isLiveSquad(row)
  );

  for (const orphan of orphans) {
    const { error: rpcError } = await supabase.rpc(
      "delete_squad_event_instances",
      {
        p_squad_id: orphan.squadId,
        p_template_ids: [templateId],
      }
    );
    if (rpcError) throw rpcError;
  }
};
